var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 183,
    viewBox: "0 0 64 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7746 1H33.7746V0H32.7746V1ZM32.7746 175H31.7746V176H32.7746V175ZM63.7071 175.707C64.0976 175.317 64.0976 174.683 63.7071 174.293L57.3431 167.929C56.9526 167.538 56.3195 167.538 55.9289 167.929C55.5384 168.319 55.5384 168.953 55.9289 169.343L61.5858 175L55.9289 180.657C55.5384 181.047 55.5384 181.681 55.9289 182.071C56.3195 182.462 56.9526 182.462 57.3431 182.071L63.7071 175.707ZM0 2H32.7746V0H0V2ZM31.7746 1V175H33.7746V1H31.7746ZM32.7746 176H63V174H32.7746V176Z",
    fill: "#E69D37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorLeft);
export default __webpack_public_path__ + "static/media/vectorLeft.166651db5bb3c97204f8357d485c11fd.svg";
export { ForwardRef as ReactComponent };